module.exports = __webpack_public_path__ + "static/media/pin.fd0ed918.svg";